import './scripts/common';
import './scripts/common-nav';

let _config = window['_config'] || {};
import {translate} from '@elements/translations';
import {findIn, find} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({submitOnReset:true});

import * as conditionalForm from './scripts/conditional-form';
conditionalForm.init();

import * as historyBack from './scripts/history-back';
historyBack.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();